/**
 * Обёртка экранов входа/настройки/регистрации/сброса: центрированная карточка с брендом. На
 * внутреннем адресе кабинета сотрудников (team-zone-login-page) под брендом — заметная плашка
 * «Кабинет сотрудников Центрики»: сотрудник видит, что он на своём адресе, а клиент — что не на
 * своём.
 */
import { type ReactNode } from 'react'
import { ShieldCheck } from 'lucide-react'
import { LoginCard } from '@/design-system/components/layout/login-card'
import { Brand } from '@/design-system/components/primitives/brand'
import { useEntryZone } from '@/app/entry-zone'
import { cn } from '@/lib/utils'

export interface AuthShellProps {
  subtitle?: string
  children: ReactNode
  footer?: ReactNode
}

/** Плашка внутреннего адреса — текстом, не только цветом. */
export function TeamZoneBanner() {
  return (
    <div
      role="note"
      className="mt-4 rounded-10 border border-accent bg-accent-bg px-3 py-2.5 text-accent-txt"
    >
      <div className="flex items-center gap-2 font-semibold">
        <ShieldCheck className="size-4 shrink-0 stroke-current" aria-hidden />
        Кабинет сотрудников Центрики
      </div>
      <p className="mt-0.5 text-13">Только для сотрудников — доступ из сети офиса</p>
    </div>
  )
}

export function AuthShell({ subtitle, children, footer }: AuthShellProps) {
  const zone = useEntryZone()
  const team = zone?.zone === 'team'
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg p-5">
      <LoginCard>
        <Brand />
        {team ? <TeamZoneBanner /> : null}
        {subtitle ? (
          <p className={cn('mb-6 text-txt-secondary', team ? 'mt-3' : 'mt-1.5')}>{subtitle}</p>
        ) : (
          <div className="mb-4" />
        )}
        {children}
        {footer ? <div className="mt-4 text-center text-13">{footer}</div> : null}
      </LoginCard>
    </div>
  )
}
